let curriculum;
export const getCurriculum = () => curriculum;
export const setCurriculum = (c) => {
  curriculum = c;
};
